import { tryParseNumber } from '~/utils';
import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const pageNumberParameter: QueryParameterSchema<'pageNumber'> = {
  getDefaultValue: ({ defaultParameters }) => defaultParameters.pageNumber,
  getValue: ({ parameters }) => parameters.pageNumber,
  toUrlSearchParams: ({ value }) => ({ 'page[number]': `${value}` }),
  toSearchQuery: ({ value }) => ({ 'page[number]': value }),
  fromUrlSearchParams: ({ urlSearchParams, defaultValue }) => ({
    pageNumber: tryParseNumber(urlSearchParams.get('page[number]')) || defaultValue,
  }),
  sanitize: ({ value, defaultValue }) => {
    if (value && value > 0) return { pageNumber: value };
    return { pageNumber: defaultValue };
  },
};
